import {hasFeatureFlag} from '../../util/FeatureUtil';
import {hasAiAccess, isViewerCollaboratorSeat} from '../../util/PermissionsUtil';

/** Whether existing Nova threads are shown to this viewer: the company's `nova_agent_invocation`
 * flag alone. Reading a thread is not using AI, so a viewer without AI_ACCESS, or on a
 * Collaborator seat, still reads a teammate's Nova output on a shared task. */
export const isNovaThreadReadable = (): boolean => hasFeatureFlag('nova_agent_invocation');

/** Whether this viewer may act on Nova: invoke, retry, reply, change agent. Needs the flag, the
 * viewer's own AI permission, and a seat other than Collaborator (the same seat rule as
 * `canUseAgentChat`), so admins can keep Contributor-seat users off Nova. Every Nova column,
 * control, view option and reply mode asks this, so a viewer who may not act sees no control the
 * server would refuse. */
export const isNovaInvocationEnabled = (): boolean => isNovaThreadReadable() && hasAiAccess() && !isViewerCollaboratorSeat();
